export default "__VITE_ASSET__B5LJl8VV__"